import React from "react";
import { Link, useLocation } from "react-router-dom";

export const Menu: React.FC = () => {
  const location = useLocation();
  return (
    <div className="container-fluid bg_branco">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <ul className="nav-menu">
              <li>
                <Link
                  to="/"
                  className={`bt ${location.pathname === "/" ? "active" : ""}`}
                >
                  Catálogo
                </Link>
              </li>
              <li>
                <Link
                  to="/loja"
                  className={`bt ${location.pathname === "/loja" ? "active" : ""}`}
                >
                  Loja
                </Link>
              </li>
              <li>
                <Link
                  to="/contato"
                  className={`bt ${location.pathname === "/contato" ? "active" : ""}`}
                >
                  Contato
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
